"use client";
import { useEffect } from "react";
import { useRouter, usePathname } from "next/navigation";

export default function Home() {
  const router = useRouter();
  const pathname = usePathname();

  useEffect(() => {
    console.log("Current pathname:", pathname); // Debugging
    if (pathname === "/") {
      router.push("/home");
    }
  }, [router, pathname]);

  return null;
}
